exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".popUpWizard-dialogClassName {\n  width: 980px;\n}\n.contentBody {\n  font-size: 20px;\n}\n.popUpWizard-Button {\n  background-color: transparent;\n  border: none;\n  padding-bottom: 200%;\n  padding-top: 200%;\n}\n.popUpWizard-modal-header {\n  border-bottom: 0px solid #BDBDBD;\n}\n.popUpWizard-modal-footer {\n  border-top: 0px solid #BDBDBD;\n}\n", ""]);

// exports
